<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :persistenceKey="'point-of-sale-history'"
    :setLoading="setLoading"
    :loadDataGrid="loaded"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";

import TransactionListTemplate from "@/templates/transaction-list";
import {
  PointOfSalesTab,
  GetIndexByTabName,
} from "@/_models/tabdata/sales/point-of-sales-tabs";
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      setLoading: false,
      loaded: false,
      gcPopupCustomerStatementConfig: {},
    };
  },
  computed: {
    defaultDateFilterValue() {
      return new Date();
    },

    setScreenConfig() {
      var config = {
        title: "Point of Sale Transactions",
        ScreenName: "Point of Sale Transactions",
        selectedIndex: GetIndexByTabName("Transaction History"),
        tabs: PointOfSalesTab,
        exportFileName: "Point of Sale Transactions",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "POSHeader",
              serverPaging: true,
              allowGrouping: false,
              select: this.getSelectFields(this.getColumns),
              postProcessCallback: this.posTransactionPostProcessCallback,
            },
          },

          toolbar: {
            search: false,
            columnChooser: false,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [],
            filterOnEnter: true,
          },
          columns: this.getColumns,
        },
      };

      return config;
    },
    getColumns() {
      return [
        {
          screenField: "Invoice",
          dataField: "InvoiceCode",
          gridDataField: "InvoiceCode",
          gridLabel: "Transaction",
          sortOrder: "desc",
          width: ColumnWidth.TransactionNo.width,
          maxWidth: ColumnWidth.TransactionNo.minWidth,
        },
        {
          screenField: "Customer",
          sortIndex: 0,
          cellTemplateRecord: {
            primary: [
              {
                dataField: "CustomerName",
              },
            ],
            secondary: [
              {
                dataField: "CustomerCode",
              },
            ],
          },
          exportFields: [
            {
              dataField: "CustomerCode",
              label: "Customer Code",
            },
            {
              dataField: "CustomerName",
              label: "Customer Name",
            },
          ],
        },
        {
          screenField: "Date",
          gridLabel: "Date",
          filterDataField: "DateCreated",
          dataField: "DateCreated",
          type: "DateTime",
          displayFormat: "dddd hh:mm",
          maxWidth: ColumnWidth.DateTime.width,
        },
        {
          screenField: "DateIn",
          gridLabel: "Date",
          filterLabel: "Date",
          filterDataField: "DateIn",
          filterIndex: 2,
          filterOperator: "=",
          filterDefaultValue: this.defaultDateFilterValue,
          width: ColumnWidth.Date.width,
          maxWidth: ColumnWidth.Date.minWidth,
          visible: false,
        },

        {
          screenField: "TransactionType",
          dataField: "PayMethod",
          gridLabel: "Method",
          gridDataField: "PayMethod",
          visible: true,
          showInColumnChooser: false,
          width: ColumnWidth.PaymentType.width,
          maxWidth: ColumnWidth.PaymentType.minWidth,
        },
        {
          screenField: "Total",
          gridLabel: "Total",
          filterLabel: "Total",
          gridDataField: "TotalDue",
          width: ColumnWidth.Price2DecimalPoints.width,
          maxWidth: ColumnWidth.Price2DecimalPoints.minWidth,
        },
        {
          screenField: "Invoice",
          dataField: "InvoiceCode",
          filterIndex: 0,
          filterLabel: "Transaction",
          filterDataField: "InvoiceCode",
          type: "Integer",
          visible: false,
          showInColumnChooser: false,
        },
      ];
    },
  },
  methods: {
    posTransactionPostProcessCallback(data) {
      // data.forEach((element) => {
      //   if (element.DateIn) element.DateIn = element.DateIn.dateWithOffset();
      // });
      return data;
    },

    // eslint-disable-next-line no-unused-vars
    navigateToDestination(e) {
      this.$router.push({
        path: `customer`,
      });
    },
    rowClickCallBack(e) {
      if (
        e.rowType == "data" &&
        e.column.screenField != "Status" &&
        e.column.screenField != "GridRecordEllipsisMenu"
      ) {
        this.onRowClicked(e, {
          view: this,
          page: "point-of-sale-detail",
          mode: "edit",
          idProperty: "InvoiceCode",
          query: { from: "point-of-sale-history" },
        });
      }
    },
  },

  async created() {
    this.setLoading = false;
    this.loaded = true;
  },
};
</script>

<style lang="scss"></style>
